// eslint-disable-next-line import/no-cycle
import exceptionHandler from '../utils/exceptionHandler.platform';
import background from './portalGates/toBackground';
import { setActiveSchemaMigration } from './stateUpdaters/clientStateUpdaters/other';

const onDatabaseSchemaConflict = async () => {
  exceptionHandler.captureException(
    new Error('Database schema conflict (RxError DB6) — clearing local data'),
    { extra: { phase: 'onDatabaseSchemaConflict' } },
  );
  await setActiveSchemaMigration(true);
  await background.clearAllLocalData();
};

export default onDatabaseSchemaConflict;
